import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { CardholdersControllerModule } from './controllers/CardholdersController';

export const CardholdersView = angular
  .module('acme.view.application.cardholders', [uiRouter, 'ui.bootstrap', CardholdersControllerModule])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const cardholders = {
      name: 'application.cardholders',
      url: '/cardholders',
      views: {
        'subview-main': {
          controller: 'CardholdersController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/cardholders/cardholders.tpl.html',
        },
      },
      data: {
        pageTitle: ' ',
      },
    };

    $stateProvider.state(cardholders);
  }).name;
